import gql from 'graphql-tag';
import apolloClient from '../../apollo/apollo';

const state = {
    users: [],
    user: null,
    permissions: JSON.parse(localStorage.getItem('permissions')) ?? [],
    naveMenu: [],
    loggedUser: 'null',
    roles: [],
    token: localStorage.getItem('token') || '',
};

const getters = {
    getPermissions: (state) => state.permissions,
    getAllUsers: (state) => state.users,
    getSingleUser: (state) => state.user,
    getLoggedUser: (state) => state.loggedUser,
    isAuthenticated: (state) => !!state.token,
    getRoles: (state) => state.roles,
};

const mutations = {
    setAllUsers(state, users) {
        state.users = users.slice();
    }, setSingleUser(state, user) {
        state.users = [...state.users, user];

    }, setPermissionsMutation(state, permissions) {
        state.permissions = permissions;
    }, setloggedUser(state, user) {
        state.loggedUser = user
    }, setToken(state, token) {
        state.token = token;
    }, fetchRoles(state, roles) {
        state.roles = roles;
    }, logout(state) {
        state.token = '';
        state.user = null;
        state.permissions = [];
    },
};

const actions = {
    async changePasswordByUserId({ commit }, { newPassword, userId }) {

        try {
            const response = await apolloClient.mutate({
                mutation: gql`
          mutation changeUserPassword($newPassword: String!, $userId: Int!) {
            changeUserPassword(newPassword: $newPassword, userId: $userId) {
              id
            }
          }
        `, variables: {
                    newPassword: newPassword, userId: +userId
                }, context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                },
            });

            if (response.data.changeUserPassword.errors) {
                console.error('Failed to change user:', response.data.changeUserPassword.errors);
                return false;
            } else {
                return true;
            }

            // commit('setSingleUser', response.data.createUser);
        } catch (error) {
            console.error('Failed to create user:', error.message);
        }

    },

    setPermissions({ commit }, permissions) {
        commit('setPermissionsMutation', permissions);
    },

    async login({ commit }, { password, phoneNumber }) {
        try {
            const response = await apolloClient.mutate({
                mutation: gql`
          mutation login($email: String!, $password: String!) {
            login(password: $password, email: $email) {
                accessToken
                permissions
                otp
                user{
                  id
                  email
                  onboardingCompleted
                  contact{
                    firstName
                    lastName
                  }
                }
            }
          }
        `, variables: { password: password, email: phoneNumber },
            });

            if (response.errors) {
                return { success: false, message: response.errors[0].message };
            }

            if (response.data.login.otp == 1) {
                return { success: false, otp: true, message: "OTP is required" };
            }
            const accessToken = response.data.login.accessToken;
            await localStorage.setItem('accessToken', accessToken);
            await localStorage.setItem('permissions', JSON.stringify(response.data.login.permissions));
            await localStorage.setItem('user', JSON.stringify(response.data.login.user));

            await commit('setToken', accessToken);
            await commit('setloggedUser', response.data.login.user);
            await commit('setPermissionsMutation', response.data.login.permissions);

            return { success: true };
        } catch (error) {
            console.error('Login error:', error);
            return { success: false, message: error.message };
        }
    },
    async completeOnboarding({ commit, state }) {
        try {
            await apolloClient.mutate({
                mutation: gql`
                    mutation completeOnboarding {
                        completeOnboarding
                    }
                `,
                context: { headers: { Authorization: 'Bearer ' + (localStorage.getItem('accessToken') || localStorage.getItem('token') || '') } }
            });
            const currentUser = state.loggedUser || JSON.parse(localStorage.getItem('user') || '{}');
            const updatedUser = { ...currentUser, onboardingCompleted: true };
            await localStorage.setItem('user', JSON.stringify(updatedUser));
            commit('setloggedUser', updatedUser);
            return true;
        } catch (error) {
            console.error('Failed to complete onboarding on server:', error);
            return false;
        }
    },
    logout({ commit }) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('permissions');
        localStorage.removeItem('user');
        localStorage.removeItem('vuex');
        // localStorage.clear();

        commit('logout');
    },

    async signup({ commit }, { phoneNumber }) {
        try {
            const response = await apolloClient.mutate({
                mutation: gql`
                    mutation signupParent($phoneNumber: String!) {
                        signupParent(phoneNumber: $phoneNumber) {
                            message
                            success
                        }
                    }
                `, variables: { phoneNumber },
            });

            if (response.errors) {
                return { success: false, message: response.errors[0].message };
            }

            return { success: response.data.signupParent.success, message: response.data.signupParent.message };
        } catch (error) {
            // Handle GraphQL errors that are thrown
            if (error.graphQLErrors && error.graphQLErrors.length > 0) {
                return { success: false, message: error.graphQLErrors[0].message };
            }
            return { success: false, message: error.message };
        }
    },

    async editPatientFormSign({ commit }, { forms, patientFormSignId }) {
        try {
            // Debug: Log the forms data before transformation
            console.log("Forms data before transformation:", forms);

            // Extract items from grouped structure and flatten to single array
            const flatForms = forms.reduce((acc, group) => {
                if (group.items && Array.isArray(group.items)) {
                    return acc.concat(group.items);
                }
                return acc;
            }, []);

            // Transform forms to the new structure that the backend expects
            // Ensure all forms have valid name, value, and type fields
            const formData = flatForms.map(form => ({
                name: form.name || '', // Ensure name is never null
                value: form.value || '', // Ensure value is never null
                type: form.type || 'text' // Ensure type is never null
            }));

            // Debug: Log the transformed form data
            console.log("Flattened forms:", flatForms);
            console.log("Transformed form data:", formData);

            const response = await apolloClient.mutate({
                mutation: gql`
                    mutation editPatientFormSign($patientFormSignInput: PatientFormSignInput) {
                        editPatientFormSign(patientFormSignInput: $patientFormSignInput) {
                            id
                            pdfBase64
                        }
                    }
                `,
                variables: {
                    patientFormSignInput: {
                        patientFormSignId: +patientFormSignId,
                        forms: formData
                    }
                },
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                },
            });

            if (response.data && response.data.editPatientFormSign) {
                return { success: true, pdfBase64: response.data.editPatientFormSign.pdfBase64 };
            } else {
                throw new Error('Failed to edit patient form sign');
            }
        } catch (error) {
            console.error('Failed to edit patient form sign:', error);
            return { success: false, message: error.message };
        }
    },

    // Password Reset Actions
    async requestPasswordReset({ commit }, { phone }) {
        try {
            const response = await apolloClient.mutate({
                mutation: gql`
                    mutation requestPasswordReset($phone: String!) {
                        requestPasswordReset(phone: $phone) {
                            success
                            message
                        }
                    }
                `,
                variables: { phone },
            });

            return response.data.requestPasswordReset;
        } catch (error) {
            console.error('Request password reset error:', error);
            return { success: false, message: error.message };
        }
    },

    async validatePasswordResetToken({ commit }, { token }) {
        try {
            const response = await apolloClient.mutate({
                mutation: gql`
                    mutation validatePasswordResetToken($token: String!) {
                        validatePasswordResetToken(token: $token) {
                            valid
                            message
                            userEmail
                        }
                    }
                `,
                variables: { token },
            });

            return response.data.validatePasswordResetToken;
        } catch (error) {
            console.error('Validate token error:', error);
            return { valid: false, message: error.message, userEmail: null };
        }
    },

    async resetPasswordWithToken({ commit }, { token, newPassword }) {
        try {
            const response = await apolloClient.mutate({
                mutation: gql`
                    mutation resetPasswordWithToken($token: String!, $newPassword: String!) {
                        resetPasswordWithToken(token: $token, newPassword: $newPassword) {
                            success
                            message
                        }
                    }
                `,
                variables: { token, newPassword },
            });

            return response.data.resetPasswordWithToken;
        } catch (error) {
            console.error('Reset password error:', error);
            return { success: false, message: error.message };
        }
    },

};

export default {
    state, getters, mutations, actions,
};
